import { SubmissionErrors } from 'final-form';
import React from 'react';
import { Form, Field } from 'react-final-form';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Col, Row } from 'antd';
import { RouteComponentProps } from 'react-router-dom';

import { StoreI } from '~src/rootReducer';
import { topicTypes } from '~src/modules/topics/constants/topicTypes';
import CardsRadio from '~src/shared/form/cardsRadio/CardsRadio';
import { TopicSubject } from '~src/interfaces/topic.interface';
import { FieldType } from '~src/types';
import CustomFormInput from '~src/shared/form/inputs/FormInput';
import SecondaryButton from '~src/shared/buttons/basicButtons/SecondaryButton.sc';
import { ButtonWrapper } from '~src/modules/attributes/components/add/attributeAddForm.sc';
import { composeValidators } from '~src/shared/reactFinalForm/validators';
import { validatorMaxLength40, validatorRequired } from '~src/services/validators';
import { routes } from '~src/routingConfig';

import { FormValues } from './TopicAdd';
import { CreateTopicBtn, StyledForm } from './topicAddForm.sc';

interface OwnProps extends Pick<RouteComponentProps<any>, 'history'> {
  contentLocale: string;
  onFrmSubmit: (topic: FormValues) => Promise<SubmissionErrors>;
}

interface StateProps {
  loadingAddTopic: boolean;
}

type Props = OwnProps & StateProps & WithTranslation;

class TopicAddForm extends React.Component<Props> {
  goToTopics = () => {
    this.props.history.push(routes.contentTopics.topics);
  };

  renderField = ({ autoFocus, input, label, meta: { touched, error, submitError }, labelKey }: FieldType) => {
    return (
      <CustomFormInput
        {...input}
        autoFocus={autoFocus}
        error={touched ? error || submitError : null}
        label={label}
        type={input.type}
        labelKey={labelKey}
      />
    );
  };

  render() {
    const { t } = this.props;
    const topicNamePlaceholder = t('x.topics.add.input.placeholder.topic_name');
    return (
      <Form initialValues={{ subject: TopicSubject.General }} onSubmit={this.props.onFrmSubmit}>
        {({ handleSubmit, values }) => (
          <StyledForm onSubmit={handleSubmit} noValidate>
            <Row gutter={{ lg: 30, md: 30, sm: 16 }} type="flex">
              {topicTypes.map((item, index) => (
                <Col span={8} key={item.value}>
                  <label htmlFor={`subject_${index}`}>
                    <CardsRadio
                      t={t}
                      itemTypeSelected={values.subject}
                      item={item}
                      index={index}
                      fieldName="subject"
                    />
                  </label>
                </Col>
              ))}
            </Row>
            <Row>
              <Col style={{ marginTop: '60px', width: '100%' }}>
                <Field
                  autoFocus
                  name="name"
                  label={topicNamePlaceholder}
                  type="text"
                  children={this.renderField}
                  validate={composeValidators([validatorRequired, validatorMaxLength40])}
                  labelKey="x.topics.add.input.placeholder.topic_name"
                />
              </Col>
            </Row>
            <ButtonWrapper>
              <SecondaryButton type="button" onClick={this.goToTopics}>
                <span data-translation="x.attributes.add.button_cancel">
                  {t('x.attributes.add.button_cancel')}
                </span>
              </SecondaryButton>
              <CreateTopicBtn isLoading={this.props.loadingAddTopic}>
                <span data-translation="x.topics.add.button.create">{t('x.topics.add.button.create')}</span>
              </CreateTopicBtn>
            </ButtonWrapper>
          </StyledForm>
        )}
      </Form>
    );
  }
}

const mapStateToProps = (state: StoreI) => {
  return {
    loadingAddTopic: state.topics.loadingAdd,
  };
};

const TopicAddFormT = withTranslation()(TopicAddForm);
const TopicAddFormSuper = connect(mapStateToProps)(TopicAddFormT);

export default TopicAddFormSuper;
